import { registryApi } from '../clients/AxiosClients'

/**
 * Retorna todas as parcelas cadastradas no banco de dados
 */
const getAllParcelas = async () => {
	return registryApi.get('v1/Parcela')
}

/**
 * Retorna todas as parcelas cadastradas no banco de dados com paginação
 * @param {number} PagNumber - Número da página
 * @param {number} PagSize - Tamanho da página
 * @param {string} FilteringWord - Palavra chave busca  */

const getAllParcelasPagination = async (PagNumber, PagSize, FilteringWord) => {
	return registryApi.post('v1/Parcela/GetToCrudTable', { PagNumber, PagSize, FilteringWord })
}

/**
 * Cadastrar nova parcela no banco de dados
 * @param {Object} body Parcela que será cadastrada
 */
const createParcela = async (body) => {
	return registryApi.post('v1/Parcela', body)
}

/**
 * Atualiza Parcela no banco de dados
 * @param {Object} body Parcela que será atualizada
 */
const updateParcela = async (body) => {
	return registryApi.put('v1/Parcela', body)
}

/**
 * Lista dos ids de Parcela que devem ser excluidos do banco de dados
 * nome do parametro deve ser data pois método DELETE do axios obrigatoriamente recebe um argumento 'data'
 * @param {Array} data Lista dos ids de Parcela
 */
const deleteParcelaByIdList = async (data) => {
	return registryApi.delete('v1/Parcela/DeleteByIdList', { data })
}

export const updateOrdemServicoParcela = async (ospl) => {
	return registryApi.put('v1/Parcela/UpdateOspl', ospl)
}
export const createOrdemServicoParcela = async (ospl) => {
	return registryApi.post('v1/Parcela/CreateOspl', ospl)
}

export {
	getAllParcelas,
	createParcela,
	updateParcela,
	deleteParcelaByIdList,
	getAllParcelasPagination,
}
